module.exports = __webpack_public_path__ + "static/media/checked.e86a8a91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checked.svg
// module id = 285
// module chunks = 7